import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IAnswerOrder, IQuestion, ISaveAnswerParams } from '@interfaces/index';
import { Subject, debounceTime, distinctUntilChanged, switchMap } from 'rxjs';
import { AssessmentService } from '../../services/assessment.service';

@Component({
  selector: 'app-ranking',
  templateUrl: './ranking.component.html',
  styleUrl: './ranking.component.scss'
})
export class RankingComponent {

  @Input() question: IQuestion | null = null;
  @Input() token: string | null = null;
  @Output() onNext: EventEmitter<void> = new EventEmitter()

  constructor(
    public assessment_service: AssessmentService
  ) {}
  
  drop(list: IAnswerOrder[], event: CdkDragDrop<string[]>) {
    moveItemInArray(list, event.previousIndex, event.currentIndex);
    this.assessment_service.saveAnswer<ISaveAnswerParams<IAnswerOrder[]>>({
      answer: list,
      question_id: this.question?.question_id as number,
      token: this.token as string
    }).subscribe(
      () => {
        (this.question as IQuestion).user_answer_ind = 1
      }
    )
  }

  saveAnswer() {
    this.assessment_service.saveAnswer<ISaveAnswerParams<IAnswerOrder[]>>({
      answer: this.question?.answer_order ?? [],
      question_id: this.question?.question_id as number,
      token: this.token as string
    }).subscribe(
      () => {
        (this.question as IQuestion).user_answer_ind = 1
        this.onNext.emit()
      }
    )
  }
}
